function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3756 5.68667C11.3756 6.94156 10.9681 8.10077 10.2818 9.04125L13.7436 12.5052C14.0855 12.8469 14.0855 13.4019 13.7436 13.7437C13.4018 14.0854 12.8467 14.0854 12.5049 13.7437L9.04302 10.2797C8.10235 10.9687 6.94292 11.3733 5.68778 11.3733C2.54583 11.3733 0 8.828 0 5.68667C0 2.54533 2.54583 0 5.68778 0C8.82973 0 11.3756 2.54533 11.3756 5.68667ZM5.68778 9.62359C7.86171 9.62359 9.62547 7.86018 9.62547 5.68667C9.62547 3.51316 7.86171 1.74974 5.68778 1.74974C3.51384 1.74974 1.75009 3.51316 1.75009 5.68667C1.75009 7.86018 3.51384 9.62359 5.68778 9.62359Z",
  fill: "black"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.99467353.svg";
export { ForwardRef as ReactComponent };